export default {
  About: { title: "About", rune: "diamond", path: "/about" },
  Projects: { title: "Projects", rune: "stair", path: "/projects" },
  Resume: { title: "Resume", rune: "arrow", path: "/resume" },
  Contact: { title: "Contact", rune: "sigma", path: "/contact" }
};



// WEBPACK FOOTER //
// ./src/constants/navigation.js